import * as types from './dashboardActionTypes';
import { DashboardActionKeys as keys } from './dashboardActionKeys';
import { ISalesDashboardApiResponse } from './dashboardInterfaces';

export const dashboardActionCreators = {
  fetchSalesDashboard: (): types.FetchSalesDashboard => ({
    type: keys.FETCH_SALES_DASHBOARD
  }),
  setSalesDashboard: (payload: ISalesDashboardApiResponse): types.SetSalesDashboard => ({
    payload,
    type: keys.SET_SALES_DASHBOARD
  })
};
